<script lang="ts">
  import { StoryblokComponent } from '@storyblok/svelte';
  import type { PageBlock } from '@storyblok-types';
  const { blok, isHomePage }: { blok: PageBlock; isHomePage?: boolean } = $props();
</script>

{#each blok.body ?? [] as item (item._uid)}
  <StoryblokComponent blok={item} {isHomePage} blockIndex={blok.body?.indexOf(item)} />
{/each}
